import { Popover } from '@mui/material';

import { Dispatch, SetStateAction, useEffect } from 'react';

import { IObjectData } from 'common/api/type-def';
import FeedbackForm from 'common/components/FeedbackForm/FeedbackForm';

import styles from './FeedbackPopper.module.scss';

interface IFeedbackPopperProps {
	objectType: string;
	module: string;
	anchorEl: HTMLElement | null | undefined;
	feedBackClicked: boolean;
	emptyResponse: any;
	submitFeedback: (feedbackData: any) => void;
	cancelFeedback: (feedbackData: any) => void;
	isLike?: boolean;
	feedbackInfo: any;
	handleClickAway: any;
	objectData: IObjectData;
	setAnchorEl?: Dispatch<SetStateAction<HTMLElement | null>>;
}

const FeedbackPopper: React.FC<IFeedbackPopperProps> = (
	props: IFeedbackPopperProps,
) => {
	const {
		objectType,
		module,
		anchorEl,
		feedBackClicked,
		emptyResponse,
		submitFeedback,
		cancelFeedback,
		isLike,
		feedbackInfo,
		handleClickAway,
		objectData,
		setAnchorEl,
	} = props;

	useEffect(() => {
		if (!feedBackClicked) {
			handleClose();
			handleClickAway();
		}
	}, [feedBackClicked]);
	const handleClose = () => {
		if (setAnchorEl) {
			setAnchorEl(null);
			handleClickAway();
		}
	};
	const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;
	return (
		<Popover
			disableAutoFocus
			id={id}
			anchorEl={anchorEl}
			open={open}
			data-testid="popper"
			onClose={handleClose}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'center',
			}}
		>
			{feedBackClicked && (
				<div className={styles['feedbackform-wrapper']}>
					<FeedbackForm
						module={module}
						objectType={objectType}
						messageId=""
						objectData={objectData}
						feedbackData={feedbackInfo || emptyResponse}
						isLikeView={isLike || false}
						handleCancelFeedback={cancelFeedback}
						handleSubmitFeedback={submitFeedback}
					/>
				</div>
			)}
		</Popover>
	);
};
export default FeedbackPopper;
